export const ALERT_PROTOCOL_TABLE_HEADER = [
  "Note Section",
  "Occurence",
  "Duration",
  "Rate",
  "Status",
  "OAC",
  "Alert",
  "Actions",
];

export const METRICS = [
  {
    value: "rate",
    label: "Rate",
  },
  { value: "duration", label: "Duration" },
  { value: "percentage_change", label: "Percentage Change" },
  {
    value: "status",
    label: "Status",
  },
  {
    value: "count",
    label: "Count",
  },
];

export const OPERATORS = [
  {
    value: "gt",
    label: "Greater Than",
  },
  {
    value: "lt",
    label: "Less Than",
  },
  {
    value: "gte",
    label: "Greater Than or Equal To",
  },
  {
    value: "lte",
    label: "Less Than or Equal To",
  },
  {
    value: "eq",
    label: "Equal To",
  },
  {
    value: "ne",
    label: "Not Equal To",
  },
];

export const REPORT_NOTE_SECTIONS = [
  { value: "battery", label: "Battery" },
  { value: "af burden", label: "AF Burden" },
  { value: "arrhythmia", label: "Arrhythmia" },
];

export const OCCURRENCE_OPTIONS = [
  { value: "first", label: "First" },
  { value: "repeat", label: "Repeat" },
  { value: "all", label: "All" },
];

export const SUBSECTION_OPTIONS = [
  { value: "vf", label: "VF" },
  { value: "vt", label: "VT" },
  { value: "shock", label: "Shock" },
  { value: "atp", label: "ATP" },
  { value: "af", label: "AF" },
  { value: "pause", label: "Pause" },
  { value: "brady", label: "Brady" },
  { value: "svt", label: "SVT" },
];

export const STATUS_VALUES = [
  "RRT",
  "OK",
  "BOS",
  "BOL",
  "MOS",
  "OY",
  "ERI",
  "EOS",
  "EOL",
];

export const UNIT_OPTIONS = [
  { value: "year", label: "Year" },
  { value: "month", label: "Month" },
  { value: "day", label: "Day" },
  { value: "hour", label: "Hour" },
  { value: "minute", label: "Minute" },
  { value: "second", label: "Second" },
  { value: "bpm", label: "BPM" },
  { value: "", label: "-" },
];

export const OPERATOR_DISPLAY_MAP = {
  gt: ">",
  lt: "<",
  gte: ">=",
  lte: "<=",
  eq: "=",
  ne: "!=",
};

export const NOTE_SECTION_VALUES = {
  BATTERY: "battery",
  AF_BURDEN: "af burden",
  ARRHYTHMIA: "arrhythmia",
};

export const METRICS_BY_NOTE_SECTION = {
  [NOTE_SECTION_VALUES.BATTERY]: ["status", "duration"],
  [NOTE_SECTION_VALUES.AF_BURDEN]: ["percentage_change"],
  [NOTE_SECTION_VALUES.ARRHYTHMIA]: ["rate", "duration", "count"],
};

export const NOTE_SUB_SECTION_VALUES = {
  VF: "vf",
  VT: "vt",
  AF: "af",
  SVT: "svt",
  ATP: "atp",
  Shock: "shock",
  Pause: "pause",
  Brady: "brady",
};

export const UNIT_FILTER_NOTE_SECTIONS = [
  NOTE_SECTION_VALUES.BATTERY,
  NOTE_SECTION_VALUES.ARRHYTHMIA,
];

export const isUnitOptionalByMetric = (metric, noteSection) => {
  return (
    (noteSection === NOTE_SECTION_VALUES.AF_BURDEN &&
      metric === "percentage_change") ||
    (noteSection === NOTE_SECTION_VALUES.ARRHYTHMIA && metric === "count")
  );
};
